/** Shared table markup for the Stats → Overview blocks (A7Y-5020): one row per stat line, and the footnote style. */
import { TableCell, TableRow } from '@a7y/tailwind-catalyst';

export function StatRow({
  testId,
  label,
  value,
  detail,
  indent,
  title,
}: {
  testId: string;
  label: string;
  value: string;
  detail?: React.ReactNode;
  /** A sub-line of the row above it (e.g. one source of the observations total). */
  indent?: boolean;
  /** Hover text for the value, e.g. an exact figure. */
  title?: string;
}) {
  return (
    <TableRow data-testid={testId}>
      <TableCell className={indent ? 'pl-8 text-zinc-600 dark:text-zinc-300' : 'font-medium'}>{label}</TableCell>
      <TableCell className="tabular-nums" title={title}>
        {value}
      </TableCell>
      <TableCell className="text-zinc-500 dark:text-zinc-400">{detail}</TableCell>
    </TableRow>
  );
}

export function Footnote({ testId, children }: { testId: string; children: React.ReactNode }) {
  return (
    <p data-testid={testId} className="mt-2 text-xs text-zinc-500 dark:text-zinc-400">
      {children}
    </p>
  );
}
